const WORDS = ["Pitch", "Release", "Promote", "Understand", "Discover", "Build campaigns", "Grow"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-[clamp(3rem,7vw,6.5rem)] uppercase leading-none ${i % 2 ? "text-outline" : "text-pa-ink"}`}>{w}</span>
        <span className="text-glow text-2xl text-pa-orange" aria-hidden="true">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Pitch, release, promote, understand" className="overflow-hidden border-y border-white/10 bg-pa-black py-8">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row />
      <Row hidden />
    </div>
  </section>
);
